import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import {
  usDateFormat,
  FLOW_TYPES,
  getPathWithParam,
  MANAGE_DISTRIBUTION_ROUTES,
  usCurrency,
} from "../../utils";
import { Link, AddToolTip } from "../../components";
import { useHistory } from "react-router-dom";
import { faBadgeCheck } from "@fortawesome/pro-solid-svg-icons";

const InProgressTile = (props) => {
  const {
    requestName,
    amount,
    status,
    type,
    dateOfRequest,
    raisedBy,
    onDeleteClick,
    res,
    transactionType,
  } = props;

  const history = useHistory();

  const showTag = [
    "RefinancingRequestAwaitingApproval",
    "ReAmortizationRequestAwaitingApproval",
  ].includes(status);
  //const width = status == "InProgress" || status == "AwaitingApproval" ? "w-20" : "w-25";

  return (
    <>
      <div
        className={`w-100 ${
          ["InProgress"].includes(status)
            ? "active-loan-tile"
            : "awaiting-loan-tile"
        } ${showTag && "pt-0 pr-0"}`}
        onClick={() =>
          history.push(
            getPathWithParam({
              path: res?.path,
              pathParam: res?.pathParam,
            })
          )
        }
      >
        {console.log("type", transactionType, requestName)}
        {showTag && (
          <div className="ft-10 d-flex justify-content-center transaction-loan-status">
            {status == "RefinancingRequestAwaitingApproval"
              ? "Refinance Request"
              : status == "ReAmortizationRequestAwaitingApproval"
              ? "Reamortize Request"
              : null}
          </div>
        )}
        <div className={`${showTag && "pad-right-15"} d-flex w-100`}>
          <div className={"w-25"}>
            {["InProgress", "Approval In Progress"].includes(status) ||
            requestName == "RolloverIn" ? (
              <>
                {/* <span className="ft-14 card-text-color">Request</span> */}
                <p className="ft-14 m-0">
                  {requestName}-{res.withdrawalType}
                </p>
                <p className="ft-14 m-0">{type}</p>
              </>
            ) : (
              <>
                <span className="ft-16 fw-500">
                  <AddToolTip name={type ?? "-"} />
                </span>
                <p className="ft-14 m-0">{usCurrency(amount)}</p>
              </>
            )}
          </div>
          <div className={"w-25"}>
            {["InProgress", "Approval In Progress"].includes(status) && type ? (
              <>
                <span className="ft-14 card-text-color">Status</span>
                <p className="ft-14 m-0">{status ?? "General purpose"}</p>
              </>
            ) : (
              <>
                <span className="ft-14 card-text-color">Status</span>
                <p className="ft-12 fw-400 m-0 p-0 awaiting-approval-color">
                  {status == "Active" ? (
                    <FontAwesomeIcon
                      icon={faBadgeCheck}
                      className="ft-12 mr-1 active-status"
                    />
                  ) : null}
                  {showTag ? (
                    <span className="active-status">
                      <FontAwesomeIcon
                        icon={faBadgeCheck}
                        className="ft-12 mr-1 active-status"
                      />
                      Active
                    </span>
                  ) : (
                    status
                  )}
                </p>
              </>
            )}
          </div>
          <div className={"w-20"}>
            <span className="ft-14 card-text-color">Date of request</span>
            <p className="ft-14 m-0">{usDateFormat(dateOfRequest)}</p>
          </div>
          <div className={"w-20"}>
            <span className="ft-14 card-text-color">Raised by</span>
            <p className="ft-14 m-0">{raisedBy}</p>
          </div>
          {(status == "InProgress" ||
            status == "AwaitingApproval" ||
            status == "Request In Progress") && (
            <div
              className="ft-18 cursor-pointer inprogress-border-left"
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "20px",
                color: "#EB4E3D",
              }}
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteClick();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default InProgressTile;
